"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencySymbol = {
    EUR: "€",
    USD: "$",
    GBP: "£",
    MYR: "RM",
    CNY: "¥",
    JPY: "¥",
    KRW: "₩",
    IDR: "Rp",
    VND: "₫",
    THB: "฿"
};
exports.DEFAULT_DIVIDER = 1000;
